import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { Typography } from 'app/components/ui';
import { usePermissions } from 'app/api/permission-queries';

export const NoDefaultWarning = ({ documentSuperId }: { documentSuperId?: number }) => {
  const { t } = useTranslation('tag');
  const { documentPermissions } = usePermissions(documentSuperId ?? '');
  const canOpenSettings = !!documentSuperId && documentPermissions.includes('TAG_ADMIN');

  return (
    <Typography variant="body-3" color="#e07800" className="no-default-warning mt-1 mb-1">
      {t('defaults.noProjectDefaults')}
      {canOpenSettings && (
        <>
          {' '}
          <Link to="/documents/$documentId/tagging/taxonomies" params={{ documentId: String(documentSuperId) }}>
            {t('defaults.missing.link')}
          </Link>
        </>
      )}
    </Typography>
  );
};
